import { API_BASE_URL } from "../../config/api";
const PAYMENT_PAYOUT_ADMIN_BASE_PATH = `${API_BASE_URL}/api/v0/payment-payout/admin`;

export const TRANSACTION_HISTORY_TABS = [
  {
    key: "payments",
    label: "واریز",
    path: "/transactions/payments",
    endpoint: `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/transactions/history/payments/`,
    header: "لیست واریزها",
    typeLabel: "واریز",
    modalType: "deposit",
  },
  {
    key: "payouts",
    label: "برداشت از حساب",
    path: "/transactions/payouts",
    endpoint: `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/transactions/history/payouts/`,
    header: "لیست برداشت از حساب",
    typeLabel: "برداشت از حساب",
    modalType: "withdraw",
    withdrawModal: {
      transactionLabel: "برداشت از حساب",
      getDetailUrl: (code) =>
        `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/payouts/${code}/`,
      getDecisionUrl: (id) =>
        `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/payout-decision/${id}/`,
    },
  },
  {
    key: "referral-payouts",
    label: "برداشت دعوت از دوستان",
    path: "/transactions/referral-payouts",
    endpoint: `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/transactions/history/referral-payouts/`,
    header: "لیست برداشت دعوت از دوستان",
    typeLabel: "برداشت دعوت از دوستان",
    modalType: "withdraw",
    withdrawModal: {
      transactionLabel: "برداشت دعوت از دوستان",
      getDetailUrl: (code) =>
        `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/referrals/payouts/${code}/`,
      getDecisionUrl: (id) =>
        `${PAYMENT_PAYOUT_ADMIN_BASE_PATH}/referrals/payouts/${id}/decision/`,
    },
  },
];

export const TRANSACTION_HISTORY_DEFAULT_TAB = TRANSACTION_HISTORY_TABS[0];
export const TRANSACTION_HISTORY_DEFAULT_PATH =
  TRANSACTION_HISTORY_DEFAULT_TAB.path;

export function getTransactionHistoryTab(tabKey) {
  return (
    TRANSACTION_HISTORY_TABS.find((tab) => tab.key === tabKey) ??
    TRANSACTION_HISTORY_DEFAULT_TAB
  );
}
